export default __webpack_public_path__ + "static/media/dairy.00e60176.jpg";